module.exports = __webpack_public_path__ + "img/CSCO.f9da284d.png";